// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import '../../shared/shell/strings'

export const Route = createFileRoute('/platform/audit')({
  staticData: { screenId: 'ConsoleAuditScreen', access: 'platform.audit.read' },
  component: ConsoleAuditScreen,
})

function ConsoleAuditScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid="ConsoleAuditScreen">
      <PageHeader title={t('shell.nav.audit')} titleTestId="consoleAudit_titleValue" />
    </main>
  )
}
